import { REACTIVATE_EMAIL } from './helpers';
import styles from './UpgradeOverlay.module.scss';

const CONTACT_HREF = `mailto:${REACTIVATE_EMAIL}?subject=${encodeURIComponent(
  'Reactivate my Solsten account'
)}`;

// What a locked account (see helpers.ts) gets instead of the platform.
export default function UpgradeOverlay({ onLogOut }: { onLogOut: () => void }) {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1>Your Solsten platform has been upgraded</h1>
        <p>
          Your Solsten platform has been upgraded to a new system with even deeper insights and a
          suite of new capabilities. Contact us today to learn more and reactivate your account.
        </p>
        <a className={styles.contact} href={CONTACT_HREF}>
          Contact us today
        </a>
        <button className={styles.logOut} type="button" onClick={onLogOut}>
          Log out
        </button>
      </div>
    </div>
  );
}
